<template>
<div class="app-main__inner">
  <div class="row">
    <div class="col-md-12">
        <div class="app-page-title dashboard-title">
            <div class="page-title-wrapper">
                <div class="page-title-heading">
                    <div class="page-title-icon">
                        <i class="pe-7s-note2 icon-gradient bg-happy-itmeo">
                        </i>
                    </div>
                    <div>PTE Templates</div>
                </div>
            </div>
        </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-md-12">
      <div class="tabs-row">
        <ul class="nav nav-tabs">
            <li class="nav-item"><a class="nav-link active" data-toggle="tab" @click="activeTab ='Essay'">Essay</a></li>
            <li class="nav-item"><a class="nav-link" data-toggle="tab" @click="activeTab= 'SWT'">Summarised Written Text</a></li>
          
        </ul>
      </div>
    </div>
  </div> -->
  <div class="row">
      <div class="col-12 pdReader" v-if="activeTab=='Essay'" >
          <vue-pdf-app :config="config" :title="true" pdf="pdf/PTETemplates.pdf"></vue-pdf-app>
      </div>
      <div class="col-12 pdReader" v-if="activeTab=='SWT'">
          <vue-pdf-app theme="dark" :config="config" :title="true" pdf="pdf/SWT.pdf"></vue-pdf-app>
          
      </div>
  </div>
</div>
</template>
<script>
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
export default {
    components: {
    VuePdfApp
    },
    data(){
        return {
            activeTab:'Essay',
            config: {
                toolbar: {
                    toolbarViewerRight: { 
                        presentationMode: true,
                        openFile: false,
                        print: false,
                        download: false,
                        viewBookmark: true,
                        theme:'light'
                        }
                    }
            },
        }
    },
    methods:{
    }
}
</script>
<style scoped>
.tabs-row .nav-tabs{
    margin: 0 0 30px 0;
}
.pdReader
{
min-height:80vh;
border:1px solid #ccc;
padding: 0px;
}
</style>